import { render } from "./EditInstituteView.vue?vue&type=template&id=656160c4"
import script from "./EditInstituteView.vue?vue&type=script&lang=js"
export * from "./EditInstituteView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__